module.exports = __webpack_public_path__ + "static/img/2.6ea910e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/2.png
// module id = BERE
// module chunks = 1